import Penpal from 'penpal'
import ResizeObserver from 'resize-observer-polyfill'
import store from '@/store'

let penpalParent = null

if (parent !== window) {
  const connection = Penpal.connectToParent({
    methods: {
      parentUrl: (url) => {
        store.commit('app/ROOTURL_UPDATED', url)
      }
    }
  })

  connection.promise.then(parent => {
    penpalParent = parent

    const ro = new ResizeObserver((entries, observer) => {
      for (const entry of entries) {
        let {height} = entry.contentRect
        parent.resize(height + 32)
      }
    })
    ro.observe(document.querySelector('#app'))
  })
}

const scrollTo = (offset, duration) => {
  if (penpalParent) {
    penpalParent.scroll({ data: offset, duration })
  }
}

export {
  scrollTo
}



// WEBPACK FOOTER //
// ./src/services/iframe.js